import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'
const Services = () => {
  return (
    <section id= 'services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className='container services__container'>
        <article className="service">
          <div className='service__head'>
            <h3>Data Analytics & Visualization</h3>
          </div>
          <ul className='service__list'>
          <li>
              <BiCheck className='service__list-icon' />
              <p>Design and develop interactive dashboards and reports to support data-driven decision making.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Transform complex datasets into clear, actionable visual insights.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Build KPI tracking and performance metrics aligned with business and clinical objectives.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Ensure data accuracy, consistency, and usability across reporting solutions.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Collaborate with stakeholders to translate requirements into meaningful analytics.</p>
            </li>
          </ul>
        </article>
        {/* END OF Data Analytics & Visualization */}
        <article className="service">
          <div className='service__head'>
            <h3>Data Engineering & Application Development</h3>
          </div>
          <ul className='service__list'>
          <li>
              <BiCheck className='service__list-icon' />
              <p>Develop reliable, testable, and efficient backend services for data processing and analytics.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Integrate data from multiple sources including APIs, databases, and external systems.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Design and maintain data pipelines to support reporting, analytics, and forecasting.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Optimize queries, data models, and workflows for performance and scalability.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Translate business and technical requirements into robust analytics solutions.</p>
            </li>
          </ul>
        </article>
        {/* END OF Data Engineering & Application Development */}
        <article className="service">
          <div className='service__head'>
            <h3>Data Quality, Automation & Insights</h3>
          </div>
          <ul className='service__list'>
          <li>
              <BiCheck className='service__list-icon' />
              <p>Implement data validation and quality checks to ensure accuracy and reliability of analytics outputs.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Automate recurring reports, data refreshes, and analytical workflows</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Identify trends, anomalies, and patterns to support operational and strategic decision making.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Document data definitions, metrics, and assumptions to promote consistency and trust.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Support stakeholders with ad-hoc analysis and insight-driven recommendations.</p>
            </li>
          </ul>
        </article>
        {/* END OF Data Quality, Automation & Insights*/}
      </div>
    </section>
  )
}

export default Services